export { Gamepad404Page } from './gamepad';
